<template>
  <div>
    <div class="mesgboxtop">
      <div class="flex-centerCloumn paddingtb1">
        <img
          class="mesgimg"
          :src="orderDetail.product ? orderDetail.product.thumb : ''"
        />
        <div class="textfont maincolor">核销信息</div>
      </div>

      <div class="packageDesc_shangpinmesg">
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">预约卡券</div>
          <div class="textfont">{{ orderDetail.product_name }}</div>
        </div>
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">预约服务</div>
          <div class="textfont">{{ orderDetail.service_name }}</div>
        </div>
        <!--  <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">预约日期</div>
          <div class="textfont">2022-03-09</div>
        </div> -->
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">手机号</div>
          <div class="textfont">
            {{ orderDetail.user ? orderDetail.user.mobile : "" }}
          </div>
        </div>
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">核销时间</div>
          <div class="textfont">{{ orderDetail.used_at_str }}</div>
        </div>
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">核销状态</div>
          <div class="textfont">{{ orderDetail.status_str }}</div>
        </div>
      </div>
      <div class="packageDesc_shangpinmesg" v-if="orderDetail.image">
        <div class="orderImgtop">
          <div
            v-for="(url, index) in imageUrls"
            :key="index"
            class="order-img-item"
          >
            <img class="orderimg" @click="previewImg" :src="url" />
          </div>
        </div>
      </div>
      <div class="flexAllcenter">
        <div class="textfont tipcolor1 ">
          如遇使用问题，请联系客服4008932218
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httper from "../../../api/http";
export default {
  data() {
    return {
      orderDetail: {},
      imageUrls: []
    };
  },
  created() {
    if (this.$route.params.orderDetail) {
      this.orderDetail = JSON.parse(this.$route.params.orderDetail);
      this.imageUrls = this.orderDetail.image.image_url || [];
    }
    console.log("this.orderDetail", this.orderDetail);
  },
  mounted() {},
  methods: {
    //获取微信配置信息接口
    getwechat(requestData = {}) {
      httper.get("wechat/wechat/sign-package", requestData, res => {
        console.log(res);
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ["previewImage"] // 必填，需要使用的JS接口列表
        });
      });
    },
    //预览图片
    previewImg() {
      let that = this;
      let urls = that.orderDetail.image.image_url;
      //urls.push(that.orderDetail.image.image_url)
      wx.ready(() => {
        wx.previewImage({
          // current: '', // 当前显示图片的http链接
          urls: urls // 需要预览的图片http链接列表
        });
      });
    },
    // 调用接口
    request(type = "", requestData = {}) {
      let that = this;
      switch (type) {
        //
        case "":
          httper.get(
            "",
            requestData,
            function(res) {
              if (res.code === 0) {
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
              }
            },
            true
          );
          break;
      }
    }
  }
};
</script>

<style>
.mesgboxtop {
  width: calc(100% - 20px);
  margin: 10px;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 0 10px;
  padding-bottom: 40px;
  box-sizing: border-box;
}

.packageDesc_shangpinmesg {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;

  /*    margin-bottom: 20px; */
}

.mesgimg {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
  border-radius: 25px;
}

.orderImgtop {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #f8f9fa;
}

.order-img-item {
  width: calc(33.33% - 7px);
  aspect-ratio: 1;
  margin-bottom: 10px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.order-img-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.orderimg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.order-img-item:hover .orderimg {
  transform: scale(1.05);
}
</style>



// WEBPACK FOOTER //
// src/pages/verify/verifyOrderDetail.vue